import React, { Component } from 'react'
//utils
import { Translations, convertStringToArray, convertStringToArrayForRadio } from '../../../../../utils';
//rest client
import { aemHostClient, eapiClient } from '../../../../../restClient';
// child component
import SimpleDropdown from '../../../../common/SimpleDropdown';
import Radiobutton from '../../../../common/Radio/radioButton';
// style
import './style.css'

class IEDetailSetting extends Component {

  state = {
    contributionVal: '',
    showContent: true,
    detailedSettings: [
      {
        country: "",
        accountId: "",
        currency: '',
        // odLimit: "N/A",
        // checkODLimit: '',
        interestContribution: {
          name: 'Interest Contribution',
          value: 'Interest Contribution'
        },
        baseRateCredit: {
          baseRate: "",
          baseRateCode: "",
          spread: "",
          rate: "",
          marginBaseRate: '',
          fixedValue: false,
          minimumInterest: '',
          maximumInterest: ''
        },
        tiers: []
      }
    ],
    newTiers: [],
    iefDropdown: []
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  setInputvalue(key, index, value, name, event) {
    let newDetailSetting = this.state.detailedSettings

    if (index === 'creditMarginBaseRate') {
      if ('baseRateCredit' in newDetailSetting[key]) {
        newDetailSetting[key].baseRateCredit.marginBaseRate = value
        newDetailSetting[key].baseRateCredit.fixedValue = ''
      } else {
        newDetailSetting[key] = {
          baseRateCredit: {
            ...newDetailSetting[key].baseRateCredit,
            marginBaseRate: value,
            fixedValue: ''
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'creditFixedValue') {
      if ('baseRateCredit' in newDetailSetting[key]) {
        newDetailSetting[key].baseRateCredit.fixedValue = value
        newDetailSetting[key].baseRateCredit.marginBaseRate = ''
      } else {
        newDetailSetting[key] = {
          baseRateCredit: {
            ...newDetailSetting[key].baseRateCredit,
            fixedValue: value,
            marginBaseRate: ''
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    }

    this.setState({
      detailedSettings: newDetailSetting
    })

    this.props.getIETierAndSettingData(this.state.detailedSettings)

  }
  componentWillMount() {
    if (typeof this.props.interestEnhancement.detailedSettings !== 'undefined') {
      let settingData = this.props.interestEnhancement.detailedSettings;

      for (let i = 0; i < settingData.length; i++) {
        if (settingData !== undefined) {
          if ("baseRateCredit" in settingData[i]) {
            if ("marginBaseRate" in settingData[i].baseRateCredit === false) {
              settingData[i]['baseRateCredit'].fixedValue = false
            }
          }
          else {
            settingData[i]['baseRateCredit'] = {
              fixedValue: false
            }
          }
        }
      }
      this.setState({
        detailedSettings: settingData
      })
    }
    aemHostClient("/aemData/formData/json_sow-interest-enhancement-detailed-settings-page")
      .then(({ data }) => {
        this.setState({
          detailSettingJson: data.par
        });
        this.setContributionOptions();
      });
  }

  setContributionOptions = () => {
    if (this.state.detailSettingJson !== undefined && this.state.detailSettingJson.length !== 0) {
      var convertedArray = this.translateWord(this.state.detailSettingJson.staticText_detailedSettings.options);
      let newArr = convertedArray.map((item) => {
        return {
          id: item,
          name: item
        }
      })
      this.setState({
        iefDropdown: newArr
      });
    }
  }

  componentDidUpdate() {
    if (typeof this.props.interestEnhancement.detailedSettings !== 'undefined' && this.props.interestEnhancement.detailedSettings.length > 0) {
      this.props.interestEnhancement.detailedSettings.map((item, index) => {
        var content = document.querySelectorAll('[data-content]')[index];
        if ('interestContribution' in item && content !== undefined) {
          if (item.interestContribution.value.toLowerCase().replace(/\s/g, "") === 'balancecontributiononly') {
            content.style.display = "none";
          }
        }
        return item
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.interestEnhancement && this.props.interestEnhancement.detailedSettings) {
      var detailTiersLen = [...this.props.interestEnhancement.detailedSettings];

      if (nextProps.newTiers.length > 0 && typeof nextProps.newTiers !== 'undefined' && Array.isArray(nextProps.newTiers)) {

        detailTiersLen.map((item, index) => {
          if (nextProps.newTiers.length >= 1 && detailTiersLen[index].tiers !== undefined) {
            if (item.tiers.length < nextProps.newTiers.length) {
              var newTiersLgn = nextProps.newTiers.length - item.tiers.length;
              for (let i = 0; newTiersLgn > i; i++) {
                detailTiersLen[index].tiers.push(JSON.parse(JSON.stringify(nextProps.newTiers[i])));
              }
              this.setState({
                detailedSettings: detailTiersLen,
                newTiers: nextProps.newTiers,
              });
            }
            else {
              if (nextProps.deletedIndex !== undefined && nextProps.deletedIndex !== '') {

                detailTiersLen[index].tiers.splice(nextProps.deletedIndex, 1);

                this.props._resetDeletedIndex();
                this.setState({
                  detailedSettings: detailTiersLen,
                  newTiers: nextProps.newTiers,
                });
              }
            }
          }
        })

      }
      else if (nextProps.oldTiers.tiers.length > 0) {
        var _oldTiers = [...nextProps.oldTiers.tiers];
        var obj = {};
        var updatedTiers = []
        var _tiers = _oldTiers.map(item => {
          obj.balanceForEnhancementMargin = '';
          obj.balanceEligibleAccountsForPremiumMargin = '';
          obj.tierId = null;
          updatedTiers.push(obj)
        })

        detailTiersLen.map((item, index) => {
          if (_oldTiers.length >= 1 && detailTiersLen[index].tiers !== undefined) {
            if (item.tiers.length < _oldTiers.length) {
              for (let i = 0; _oldTiers.length > i; i++) {
                detailTiersLen[index].tiers.push(JSON.parse(JSON.stringify(updatedTiers[i])));
              }
              this.setState({
                detailedSettings: detailTiersLen,
                newTiers: _oldTiers,
              });
            }
          }
        })
      }

      if (nextProps.updatedDetail.length > 1) {
        this.setState({
          detailedSettings: detailTiersLen
        })
      } else {
        this.setState({
          detailedSettings: detailTiersLen,
          newTiers: nextProps.oldTiers.tiers,
        });
      }
      this.setContributionOptions();
      this.props.getIETierAndSettingData(this.state.detailedSettings)
    }
  }

  getData = (event, index, item, key) => {
    let val = event.target.value;
    let selectedRef = `contriContent_${index}`;

    // if(val === 'Contribution Only'){
    //   this[selectedRef].style.display = "none";
    // }else {
    //   this[selectedRef].style.display = "block";
    // }

    let newDetailSetting = this.state.detailedSettings;

    if (event.target.name === 'contribution_list') {
      if (val === 'Interest Contribution') {
        newDetailSetting = this.props.interestEnhancement.detailedSettings
      }
    }

    if (event.target.name === 'baseRateCredit') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.baseRate = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            baseRate: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }

    } else if (event.target.name === 'creditCode') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.baseRateCode = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            baseRateCode: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'creditSpread') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.spread = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            spread: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'creditMinInterest') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.minimumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            minimumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'creditMaxInterest') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.maximumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            maximumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'balanceForEnhancementMargin') {
      if ('tiers' in newDetailSetting[index] && newDetailSetting[index].tiers.length > 0) {
        newDetailSetting[index].tiers[key].balanceForEnhancementMargin = val
      }
    } else if (event.target.name === 'balanceEligibleAccountsForPremiumMargin') {
      if ('tiers' in newDetailSetting[index] && newDetailSetting[index].tiers.length > 0) {
        newDetailSetting[index].tiers[key].balanceEligibleAccountsForPremiumMargin = val
      }
    } else if (val === 'Interest Contribution') {
      if ('interestContribution' in newDetailSetting[index]) {
        newDetailSetting[index].interestContribution.value = val;
        newDetailSetting[index].interestContribution.name = val;
        this[selectedRef].style.display = "block";
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          interestContribution: {
            name: val,
            value: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
        this[selectedRef].style.display = "block";
      }
    } else if (val === 'Balance Contribution Only') {
      if ('interestContribution' in newDetailSetting[index]) {
        newDetailSetting[index].interestContribution.value = val;
        newDetailSetting[index].interestContribution.name = val;
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            baseRate: "",
            baseRateCode: "",
            spread: "",
            rate: "",
            marginBaseRate: '',
            fixedValue: false,
            minimumInterest: '',
            maximumInterest: ''
          },
          tiers: []
        }
        this[selectedRef].style.display = "none";
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          interestContribution: {
            name: val,
            value: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
        this[selectedRef].style.display = "none";
      }
    }

    this.setState({
      detailedSettings: newDetailSetting
    })

    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }

  setTiersData = (tier, item, key, event) => {
    let val = event.target.value;
    //let newDetailSetting = [...this.state.detailedSettings];

    var updatedClone = this.state.detailedSettings.map((id, keys) => {
      if (keys === key) {
        id.tiers.map((i, k) => {
          if (k === item) {
            if (event.target.name === 'balanceForEnhancementMargin') {
              i.balanceForEnhancementMargin = val
            } else if (event.target.name === 'balanceEligibleAccountsForPremiumMargin') {
              i.balanceEligibleAccountsForPremiumMargin = val
            }
          }
        })
      }
      return id
    })

    this.setState({
      detailedSettings: updatedClone
    })
    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }

  dublicateSettings = (value, key) => {
    var dublicateData = this.state.detailedSettings.map((item, index) => {
      let selectedRef = `contriContent_${index}`;
      if (item.country === value.country && item.currency === value.currency) {
        item.country = value.country
        item.currency = value.currency
        item.baseRateCredit = value.baseRateCredit
        item.interestContribution = {
          name: 'Interest Contribution',
          value: 'Interest Contribution'
        }
        item.tiers = value.tiers
        this[selectedRef].style.display = "block";
        return item;
      } if (item.country !== value.country && item.currency !== value.currency) {
        return item;
      }
      return item;
    })

    this.setState({
      detailedSettings: dublicateData
    })
    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }

  _setAccountheading = (item) => {
    let setAcountjsx = [];
    this.props.accounts !== undefined && this.props.accounts.filter((otherAcc) => {
      if (otherAcc.id === item.accountId) {
        // if (otherAcc.otherAccount !== undefined && 'otherAccount' in otherAcc && otherAcc.otherAccount === true) {
        setAcountjsx.push(
          <span>
            {`${otherAcc.accountNumber !== undefined ? otherAcc.accountNumber + ',' : ''}`}
            {`${otherAcc.branchCode !== undefined ? otherAcc.branchCode + ',' : ''}`}
            {`${otherAcc.location !== undefined && otherAcc.location.name !== undefined ? otherAcc.location.name + ',' : ''}`}
            {`${otherAcc.currency !== undefined && otherAcc.currency.name !== undefined ? otherAcc.currency.name : ''}`}
            <span style={{ display: 'block', marginLeft: '140px' }}>{`${otherAcc.hsbcEntity !== undefined ? otherAcc.hsbcEntity : ''}`}</span>
          </span>
        )
        // } else {
        //   setAcountjsx.push(
        //     <span>
        //       {`${otherAcc.accountType !== undefined ? otherAcc.accountType.name + ',' : ''}`}
        //       {`${otherAcc.location !== undefined && otherAcc.location.name !== undefined ? otherAcc.location.name + ',' : ''}`}
        //       {`${otherAcc.currency !== undefined && otherAcc.currency.name !== undefined ? otherAcc.currency.name + ',' : ''}`}
        //       <span style={{ display: 'block', marginLeft: '140px' }}>{`${otherAcc.hsbcEntity !== undefined ? otherAcc.hsbcEntity : ''}`}</span>
        //     </span>
        //   )
        // }
      }
    })
    return setAcountjsx;
  }


  render() {
    if (typeof this.props.interestEnhancement !== 'undefined' && this.state.detailSettingJson !== undefined) {
      return [
        this.state.detailedSettings.map((item, key) =>
          <div className="detail-setting" key={key}>
            <div className="detail-setting--header-section">
              <dl className="detail-setting--datalist">
                <dt className="detail-setting--datalist__data_t">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.country)}</dt>
                <dd className="detail-setting--datalist__data_d">{item.country}</dd>

                <dt className="detail-setting--datalist__data_t">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.account)}</dt>
                <dd className="detail-setting--datalist__data_d">
                  {this._setAccountheading(item)}
                </dd>
              </dl>
            </div>
            <div className="detail-setting--body-section ">
              <div className="detail-setting--body-section-row gdocs-pbottom-25 gdocs-ptop-25-important">
                <div className="gdocs-pright-30">
                  <label className="gdocs-mtop-10">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.interestContribution)}</label>
                </div>
                <div>
                  {
                    this.state.iefDropdown !== undefined && this.state.iefDropdown.length !== 0 ?
                      <SimpleDropdown
                        options={this.state.iefDropdown}
                        value={typeof item.interestContribution === 'object' ? item.interestContribution.value : 'Interest Contribution'}
                        _onChange={(event) => this.getData(event, key, item)}
                        showPleaseSelectOption={false}
                        optionTextSelector="name"
                        name="contribution_list"
                        disabled={this.props.disabled}
                      />
                      : ''
                  }

                </div>
              </div>
              {
                <div ref={node => this[`contriContent_${key}`] = node} data-content={`contriContent_${key}`} className='gdocs-pbottom-25'>
                  <h1>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.credit)}</h1>
                  <div className="detail-setting--body-section-row">
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.baseRate)}</label>
                      <input
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="baseRateCredit"
                        disabled={this.props.disabled}
                        maxLength="50"
                        value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.baseRate : ''}
                      />
                    </div>
                    {!this.props.disabled
                      ? <div className="row-field">
                        <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.code)}</label>
                        <input
                          type="text"
                          onChange={(event) => this.getData(event, key, item)}
                          name="creditCode"
                          maxLength="5"
                          value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.baseRateCode : ''}
                          placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue && this.state.detailSettingJson.staticText_detailedSettings.defaultValue[1]}
                        />
                      </div>
                      : ''}

                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.spread)}</label>
                      <input
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="creditSpread"
                        disabled={this.props.disabled}
                        maxLength="7"
                        value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.spread : ''}
                      />
                    </div>
                    <div className="row-field select-radio">
                      <label className="radio-group gdocs-mright-30">
                        <Radiobutton
                          name={`creditPremium_${key}`}
                          disabled={this.props.disabled}
                          value='true'
                          _value={typeof item.baseRateCredit !== 'undefined' ? item.baseRateCredit.marginBaseRate : ''}
                          setInputvalue={this.setInputvalue.bind(this, key, 'creditMarginBaseRate')}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.margin)}
                      </label>
                      <label className="radio-group">
                        <Radiobutton
                          name={`creditPremium_${key}`}
                          disabled={this.props.disabled}
                          value='false'
                          _value={typeof item.baseRateCredit !== 'undefined' ? item.baseRateCredit.fixedValue : ''}
                          setInputvalue={this.setInputvalue.bind(this, key, 'creditFixedValue')}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.fixedValue)}
                      </label>
                    </div>
                  </div>

                  {
                    typeof item.tiers !== 'undefined' ? item.tiers.map((tier, index) =>
                      <div>
                        <h1 className="title">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.tier)} {index + 1}</h1>
                        <div className="detail-setting--body-section-row">
                          <div className="row-field">
                            <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.enhanceMarginText)}</label>
                            <input
                              type="text"
                              onChange={this.setTiersData.bind(this, tier, index, key)}
                              name='balanceForEnhancementMargin'
                              disabled={this.props.disabled}
                              value={tier.balanceForEnhancementMargin}
                              maxLength={this.state.detailSettingJson.staticText_detailedSettings.maxChars[0]}
                            />
                          </div>

                        </div>
                      </div>
                    ) : ''
                  }
                  <div className="detail-setting--footer-section">
                    <div className="footer">
                      <button className="footer-btn" disabled={this.props.disabled} onClick={this.dublicateSettings.bind(key, item)}>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.duplicate)}</button>
                      <label className="gdocs-mleft-30">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.accountSharingText)}</label>
                    </div>
                  </div>

                </div>
              }
            </div>
          </div>
        ), <div className="gdocs-clear-float"></div>,
        <div key="buttons-wrapper" className="form-buttons-save-section">
          <div className="form-buttons-wrapper">
            <button
              className="gdocs-btn-submit"
              onClick={this.props.ieDetailSettingTabData}
            >{this.translations(this.state.detailSettingJson.guidebutton_save.text)}</button>
          </div>
        </div>
      ]
    } else {
      return false;
    }
  }
}

export default IEDetailSetting



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/InterestEnhancementSummary/IEDetailSetting/index.js